import {
  getSurveyShareUsers,
  putSurveyShareUsers,
  postShareResults,
  IShareUser,
} from '../services/surveys';

export const useShareSurvey = (surveyId: string) => {
  const getShareUsers = async () => {
    const users = await getSurveyShareUsers(surveyId);
    return users;
  };

  const putShareUsers = async (departmentId: number, list: IShareUser[]) => {
    const resp = await putSurveyShareUsers(surveyId, departmentId, { access_list: list });
    return resp;
  };

  const postResults = async () => {
    const resp = await postShareResults(surveyId);
    return resp;
  };

  return {
    getSurveyShareUsers: getShareUsers,
    putSurveyShareUsers: putShareUsers,
    postShareResults: postResults,
  };
};
